import { Component, Input, output, inject } from '@angular/core';
import { MachinesSearchService, ToolingSearchService } from 'src/services';
import { StepBaseComponent } from '../../step-base.component';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateService, TranslateDirective } from '@ngx-translate/core';
import { FileUploadV2Module } from '@schenck/rotec-components';

const machineExcelTemplates = {
  de: 'Vorlage_Maschinenaufgaben_DE_V1.0.xlsx',
  en: 'Template_Machine_Tasks_ENG_V1.0.xlsx',
};
const toolingExcelTemplates = {
  de: 'Vorlage_Toolingaufgaben_DE_V1.0.xlsx',
  en: 'Template_Tooling_Tasks_ENG_V1.0.xlsx',
};

@Component({
  selector: 'tasklist-step',
  templateUrl: './tasklist-step.component.html',
  styleUrls: ['./tasklist-step.component.less'],
  imports: [FileUploadV2Module, TranslateDirective],
})
export class TaskListStepComponent extends StepBaseComponent {
  private readonly translate = inject(TranslateService);

  @Input()
  public isMachineTaskMode: boolean;
  public readonly fileUpload = output<File>();
  public errorMsg: string | SafeHtml = '';

  constructor() {
    const toolingService = inject(ToolingSearchService);
    const machinesService = inject(MachinesSearchService);

    super(machinesService, toolingService);
  }

  public upload([file]: File[]): void {
    if (!file) {
      return;
    }
    this.file = file;
    this.fileUpload.emit(file);
    this.updateWorkflowItem();
  }

  public getExcelTemplate(lang: 'de' | 'en'): string {
    return (
      './assets/excel-templates/' +
      (this.isMachineTaskMode ? machineExcelTemplates[lang] : toolingExcelTemplates[lang])
    );
  }

  public showErrorMsg(msg: string): void {
    this.errorMsg = this.translate.instant(msg);
  }
}
